// COMMON
export const ajaxTimeout = 0;
export const apiBaseURL = '/api';
export const jsonBaseURL = '/json';
export const baseUrl = 'http://localhost:9080';
export const debugLog = false;

// LOGIN
export const apiLoginUrl = '/login';
export const apiLogoutUrl = '/logout';
export const apiLoginStatusUrl = '/login/status';
export const loginSecurityCheck = '/j_password_security_check';

// LOGINS
export const apiLoginsPasswordResetUrl = `${apiBaseURL}/logins/auth/password/reset`;
export const apiLoginsLoginStatusForLoginUrl = `${apiBaseURL}/logins/{loginUUID}/status`;
export const apiLoginsPasswordResetForTokenUrl = `${apiBaseURL}/logins/auth/password/reset/{tokenUUID}`;

// PROFILE
export const apiProfilesForProfileUrl = `${apiBaseURL}/profiles/{profileUUID}`;

// PROFILES
export const apiProfilesUrl = `${apiBaseURL}/profiles`;

// PROFILES USER
export const apiProfilesUserPasswordUrl = `${apiBaseURL}/profiles/user/password`;

// APPLICATION
export const apiApplicationUrl = `${apiBaseURL}/application`;

// QUESTIONS
export const apiInstancesLinksSurveysQuestions = `${apiBaseURL}/instances/links/surveys/questions`;
export const apiInstancesLinksSurveysQuestionsForInstanceLinkUrl = `${apiBaseURL}/instances/links/{instanceLinkUUID}/surveys/questions`;
export const apiInstancesLinksSurveysQuestionsOptionsForInstanceLinkUrl = `${apiBaseURL}/instances/links/{instanceLinkUUID}/surveys/questions/options`;
export const apiInstancesLinksSurveysQuestionsOptionsUrl = `${apiBaseURL}/instances/links/surveys/questions/options`;

// INSTANCES
export const apiInstancesLinksSurveysResponsesUrl = `${apiBaseURL}/instances/links/surveys/responses`;
export const apiInstancesUrl = `${apiBaseURL}/instances`;
export const apiInstancesLinksUrl = `${apiBaseURL}/instances/links`;
export const apiInstancesLinksForInstanceUrl = `${apiBaseURL}/instances/{instanceUUID}/links`;
export const apiInstancesLinksForInstanceLinkUrl = `${apiBaseURL}/instances/links/{instanceLinkUUID}`;
export const apiInstancesLinksSurveysResponsesForInstanceLinkUuidUrl = `${apiBaseURL}/instances/links/{instanceLinkUUID}/surveys/responses`;
export const apiInstancesSurveysResponses = `${apiBaseURL}/instances/links/surveys/responses`;
export const apiInstancesSurveysResponsesForInstanceLinkUuidUrl = `${apiBaseURL}/instances/links/{instanceLinkUUID}/surveys/responses`;

// SESSIONS
export const apiSessionProfilesUrl = `${apiBaseURL}/session/profiles/{context}`;

// SURVEYS
export const apiInstancesSurveysResponsesUrl = `${apiBaseURL}/instances/surveys/responses`;
export const apiSurveysLinksForSurveyUUIDUrl = `${apiBaseURL}/surveys/{surveyUUID}/links`;
export const apiSurveysLinksUrl = `${apiBaseURL}/surveys/links`;
export const apiSurveysLinksForSurveyLinkUUIDUrl = `${apiBaseURL}/surveys/links/{surveyLinkUUID}`;

export const apiInstancesLinksSurveysResponses = `${apiBaseURL}/instances/links/surveys/responses`;

// MESSAGES
export const apiMessagesForInstanceLinkUrl = `${apiBaseURL}/instances/links/{instanceLinkUUID}/messages`;
export const apiMessagesForInstanceLinksUrl = `${apiBaseURL}/instances/links/messages`;
export const apiProfilesMessagesURL = `${apiBaseURL}/profiles/messages`;

// PHOTO
export const apiInstancesSurveysResponsesPhotographForPhotographUrl = `${apiBaseURL}/instances/surveys/responses/photographs/{photographUUID}`;
export const apiInstancesSurveysResponsesPhotographsUrl = `${apiBaseURL}/instances/surveys/responses/photographs/multipart`;

// EMAIL
export const apiNotificationsEmailsForEmailTemplateUrl = `${apiBaseURL}/notifications/emails/{emailTemplateUUID}`;

// JSON
export const jsonLoginStatusesUrl = `${jsonBaseURL}/qoc/secure/login-statuses.json`;



// WEBPACK FOOTER //
// ./src/qoc-sdk/config.js